export default {
  'en-US': {}
};
